import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: string;
  title: string;
  category: string;
  thumbnail: string;
  duration: string;
  views: string;
  rating: number;
}

export default function VideoCard({ id, title, thumbnail, duration, views, rating }: VideoCardProps) {
  return (
    <Link
      to={`/category/${categoryFromId(id)}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-video mb-3">
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          title={`${title} - 欲火视频高清资源`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <span className="absolute bottom-2 right-2 bg-black/75 text-white text-xs px-2 py-0.5 rounded">
          {duration}
        </span>
        <div className="absolute top-2 right-2 bg-accent-500 text-white text-xs font-bold px-2 py-0.5 rounded">
          {rating}
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
            <i className="ri-play-fill text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
        {title}
      </h3>
      <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-500">
        <span className="flex items-center gap-1">
          <i className="ri-eye-line"></i>
          {views}次播放
        </span>
      </div>
    </Link>
  );
}

function categoryFromId(id: string): string {
  const map: Record<string, string> = {
    '1': 'movies', '6': 'movies', '13': 'movies',
    '2': 'tv-series', '7': 'tv-series', '14': 'tv-series',
    '3': 'anime', '8': 'anime', '15': 'anime',
    '4': 'variety', '9': 'variety', '16': 'variety',
    '5': 'documentary', '10': 'documentary',
    '11': 'kids',
    '12': 'shorts',
  };
  return map[id] || 'recommended';
}